// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

/**
 * 可借閱書籍 (Lendable Books) API 服務
 */
export default {
  install(Vue) {
    Vue.prototype.$lendableBookApiService = {
      // 可借閱書籍 API 的基礎 URL 端點
      lendable_book_api_url: `${process.env.VUE_APP_DHARMA_API_URL}/lendable-books`,

      /**
       * 取得可借閱書籍列表 (支援篩選、分頁與排序)
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.lendable_book_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過關鍵字進行可借閱書籍的查詢
       * @param {string} keyword - 查詢關鍵字 (模糊比對書名、作者、登錄號、ISBN等)
       * @param {string} additional - 額外的 API 查詢參數 (例如分頁與排序)
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeyword(keyword, additional = '') {
        const url = `${this.lendable_book_api_url}?filter[of_keyword]=${keyword}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過多個關鍵字進行可借閱書籍的查詢（AND 邏輯）
       * @param {string} keywords - 以逗號分隔的多個關鍵字（例如 '金剛經,註解'）
       * @param {string} additional - 額外的 API 查詢參數 (例如分頁與排序)
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeywords(keywords, additional = '') {
        const url = `${this.lendable_book_api_url}?filter[of_keywords][0]=${keywords}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得資料筆數
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getCount(param = '') {
        const url = `${this.lendable_book_api_url}/count`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 根據書籍 ID 取得詳細資訊
       * @param {number|string} id - 書籍 ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object|null>} 詳細資料或 null
       */
      async getById(id, additional = '') {
        const url = `${this.lendable_book_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
